<section class="lead-hero curve -bottom -white" style="height: auto">
    <span class="photo"></span>
    <div class="intro">
        <div class="container">
            <div class="flow">
                <a href="/home">
                    <i class="icon icon-arrow-back"></i>
                    <span class="text">{{language.back}}</span>
                </a>
            </div>
            <div class="row">
                <div class="col-xl-6">
                    <h1 class="title">{{language.fundcompare1}}</h1>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="content-inner" style="padding-bottom: 0">
    <div class="container">
        <form method="POST" accept-charset="utf-8" action="/fund/compare/result" class="form -day">
            <section class="big-group">
                <div class="row">
                    <div class="col-md-6">
                        <section class="widget -cal -first">
                            <header>
                                <h3 class="topic-title">{{language.fundcompare2}}</h3>
                            </header>
                            <app-select defaultTitle="{{language.fundcompare4}}" [isLight]="false" [selectList]="selectListDropdown" (fundId)="getFundIdFromSelect($event)"></app-select>
                        </section>
                        <span *ngIf="id1Req" class="error-message">{{language.fundcompare5}}</span>
                    </div>
                    <div class="col-md-6">
                        <section class="widget -cal -first">
                            <header>
                                <h3 class="topic-title">{{language.fundcompare3}}</h3>
                            </header>
                            <app-select defaultTitle="{{language.fundcompare4}}" [isLight]="false" [selectList]="selectListDropdown" (fundId)="getFundIdFromSelect2($event)"></app-select>
                        </section>
                        <span *ngIf="id2Req" class="error-message">{{language.fundcompare5}}</span>
                    </div>
                </div>
            </section>
            <footer class="big-group text-center">
                <button class="btn btn-primary -brand" type="submit" (click)="gotoCompareResult()">
                    <span class="text-center">{{language.fundcompare1}}</span>
                </button>
            </footer>
        </form>
    </div>
</section>